export const CPF_MASK = '000.000.000-00';
export const CNPJ_MASK = 'AA.AAA.AAA/AAAA-00';

// Mesmo agrupamento do CPF, mas com posições alfanuméricas: enquanto o
// documento tem 11 caracteres ou menos ainda não sabemos se é CPF (só
// números) ou o início de um CNPJ alfanumérico (que pode ter letra em
// qualquer posição). Usar '0' aqui bloquearia letras antes mesmo do ngx-mask
// alternar para CNPJ_MASK, pois caracteres inválidos são descartados no
// mesmo keystroke, antes de qualquer lógica reativa no componente rodar.
const CPF_ALPHANUMERIC_MASK = 'AAA.AAA.AAA-AA';

export const CPF_CNPJ_COMBINED_MASK = `${CPF_ALPHANUMERIC_MASK}||${CNPJ_MASK}`;

export const CPF_SPECIAL_CHARACTERS = ['.', '-'];
export const CNPJ_SPECIAL_CHARACTERS = ['/', '.', '-'];
export const CPF_CNPJ_SPECIAL_CHARACTERS = ['/', '.', '-'];

export function isLikelyCpf(value: string | null | undefined): boolean {
  const normalized = `${value ?? ''}`;
  return normalized.length <= 11 && !/[a-zA-Z]/.test(normalized);
}

export function stripDocumentMask(value: string | null | undefined): string {
  return `${value ?? ''}`.replace(/[.\-/]/g, '');
}

export function normalizeDocumentForSubmit(
  value: string | null | undefined
): string {
  return stripDocumentMask(value).toUpperCase();
}
